import { IClickEventData } from 'types/analytics';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

export const TEXT_KEYS = {
    CAPTION: 'friend-referral-program',
    SUBMIT_BUTTON: 'platform-selection__submit-button',
    PAGE_TITLE: 'platform-selection__title',
    PAGE_DESCRIPTION: 'platform-selection__description',
    VALIDATION_ERROR: 'platform-selection__error'
};
export const PLATFORM_REGISTRATION_ANALYTICS = (platform: PLATFORM_TYPES): IClickEventData => ({
    location: 'page',
    category: 'interaction',
    action: `platform : ${platform}`
});
